import { RolesCell, TenantsCell } from '@components/Users/DataGridCells';
import { Button, Typography } from '@mui/material';
import {
	GridCellParams,
	GridColDef,
	GridValueFormatterParams
} from '@mui/x-data-grid';
import React from 'react';
import { ColWidth } from './common';

export const getColumnProps = (
	prefix: string,
	name: string,
	width: ColWidth,
	sortable?: boolean
): GridColDef => ({
	field: name,
	headerName: intl.tr(`${prefix}.${name}`),
	minWidth: width,
	flex: 1,
	renderHeader: () => (
		<Button
			sx={{
				justifyContent: 'flex-start'
			}}
			disabled={sortable === false}
		>
			<Typography variant="overline" color="text.secondary">
				{intl.tr(`${prefix}.${name}`)}
			</Typography>
		</Button>
	)
});

export const getColumn = (
	prefix: string,
	name: string,
	width: ColWidth,
	RenderCell?: any,
	valueGetter?: (params: GridCellParams) => any,
	sortable?: boolean
): GridColDef => {
	const col: GridColDef = getColumnProps(prefix, name, width, sortable);

	if (RenderCell) {
		col.renderCell = (props) => <RenderCell {...props} />;
	}
	if (valueGetter) {
		col.valueGetter = valueGetter;
	}

	if (sortable !== undefined) {
		col.sortable = sortable;
	}

	return col;
};

export const getDateColumn = (
	prefix: string,
	name: string,
	renderCell?: (value: any) => React.ReactNode,
	sortable?: boolean
): GridColDef => {
	const col: GridColDef = {
		...getColumnProps(prefix, name, ColWidth.xl, sortable),
		type: 'dateTime',
		getApplyQuickFilterFn:
			(searchValue) =>
			({ value }: GridCellParams) =>
				value &&
				searchValue &&
				intl
					.formatDateTime(value)
					.toLocaleLowerCase()
					.includes(searchValue.toLocaleLowerCase()),
		valueGetter: ({ value }) => value && new Date(value),
		valueFormatter: (params: GridValueFormatterParams) =>
			params.value && intl.formatDateTime(params.value)
	};

	if (sortable !== undefined) {
		col.sortable = sortable;
	}
	if (renderCell) {
		col.renderCell = renderCell;
	}

	return col;
};

export const getAuthColumns = () => [
	getColumn(
		'fields.column',
		'tenants',
		ColWidth.l,
		TenantsCell,
		undefined,
		false
	),
	getColumn('fields.column', 'roles', ColWidth.l, RolesCell, undefined, false)
];
